// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","546":"component---src-pages-[route]-tsx"}[chunkId] || chunkId) + "-" + {"245":"a34672e73ce791eb59fb","453":"7edc8a17f1205004cff2","546":"bf642fda74c1aa3cdedb","865":"bbc00953448576ef098c"}[chunkId] + ".js";
};